import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { findSensor, findSensorId } from '../_actions/user_action';
import { findUser, updateUser, registerUser, logoutAdmin } from '../_actions/user_action';
import { findSetting, updateSetting, registerSetting } from '../_actions/user_action';
import { findDevice, updateDevice, registerDevice } from '../_actions/user_action';
import '../css_admin/Header.css';
import '../css_admin/Body.css';

import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

/* Radio Group */
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';

// 주소검색 - 다음
import Post from "./Post";
import { getAdminAccount, clearSession } from '../utils/session';

const setting = require('../config/setting');
const prefixMainSensor = setting.sensor_no_site_name + setting.sensor_no_model_number + "-" + setting.sensor_no_main_type + "-";
const prefixNodeSensor = setting.sensor_no_site_name + setting.sensor_no_model_number + "-" + setting.sensor_no_node_type + "-";

function Registration() {
    const dispatch = useDispatch();

    const adminAccount = getAdminAccount() || {};

    const onLogoutHandler = async (event) => {
        event.preventDefault();
        await dispatch(logoutAdmin({ email: adminAccount.email }));
        clearSession();
        window.location.replace('/');
    };

    // 장비 및 사용자 신규 등록
    const focusRefRegisterMainSensor = useRef();
    const focusRefRegisterNodeSensor = useRef();
    const focusRefRegisterNodeSensorId = useRef();
    const focusRefRegisterLifetimeNH3 = useRef();
    const focusRefRegisterLifetimeH2S = useRef();
    const focusRefRegisterLifetimeTH = useRef();
    const focusRefRegisterUserIdEmail = useRef();
    const focusRefRegisterUserPassword = useRef();
    const focusRefRegisterUserPasswordConfirm = useRef();
    const focusRefRegisterUserCompany = useRef();
    const focusRefRegisterUserTel = useRef();
    const focusRefRegisterUserAddress = useRef();
    const focusRefRegisterUserAddressDetail = useRef();
    const focusRefRegisterUserChargeName = useRef();
    const focusRefRegisterUserCellPhone1 = useRef();
    const focusRefRegisterUserCellPhone2 = useRef();

    const [inputsRegister, setInputsRegister] = useState({
        registerMainSensor: prefixMainSensor,
        registerNodeSensor: [],
        registerNodeSensorId: [],
        registerUnitNH3: "0",
        registerUnitH2S: "0",
        registerUnitTemperature: "0",
        registerLifetimeNH3: "",
        registerLifetimeH2S: "",
        registerLifetimeTH: "",
        registerUserIdEmail: "",
        registerUserPassword: "",
        registerUserPasswordConfirm: "",
        registerUserCompany: "",
        registerUserTel: "",
        registerUserAddress: "",
        registerUserAddressDetail: "",
        registerUserPostal: "",
        registerUserLatitude: "",
        registerUserLongitude: "",
        registerUserChargeName: "",
        registerUserCellPhone1: "",
        registerUserCellPhone2: ""
    });

    const {
        registerMainSensor,
        registerUnitNH3,
        registerUnitH2S,
        registerUnitTemperature,
        registerLifetimeNH3,
        registerLifetimeH2S,
        registerLifetimeTH,
        registerUserIdEmail,
        registerUserPassword,
        registerUserPasswordConfirm,
        registerUserCompany,
        registerUserTel,
        registerUserAddressDetail,
        registerUserChargeName,
        registerUserCellPhone1,
        registerUserCellPhone2
    } = inputsRegister;

    // 장비 Part No. Gateway 중복확인
    const [checkDuplicate, setCheckDuplicate] = useState(false);
    const [existMainSensor, setExistMainSensor] = useState(false);

    const handleCheckDuplicate = (e) => {
        e.preventDefault();
        
        setCheckDuplicate(false);
        setExistMainSensor(false);

        let check_error = "";

        if (registerMainSensor.length === 0 || registerMainSensor === undefined) {
            check_error = "[장비 Part No. - Gateway]를 입력해주세요.";
            alert(check_error);
            focusRefRegisterMainSensor.current.focus();
            return;
        }

        if (registerMainSensor.length !== setting.sensor_no_total_length) {
            check_error = "[장비 Part No. - Gateway] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(check_error);
            setInputsRegister({
                ...inputsRegister,
                registerMainSensor: prefixMainSensor
            });
            focusRefRegisterMainSensor.current.focus();
            return;
        }

        // console.log(registerMainSensor.indexOf(prefixMainSensor));
        if (registerMainSensor.indexOf(prefixMainSensor) < 0) {
            check_error = "[장비 Part No. - Gateway] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(check_error);
            setInputsRegister({
                ...inputsRegister,
                registerMainSensor: prefixMainSensor
            });
            focusRefRegisterMainSensor.current.focus();
            return;
        }

        const tempSensor = registerMainSensor;
        const tempNumber = tempSensor.substring(tempSensor.length - setting.sensor_no_product_number);
        const productNumber = Number(tempNumber);

        if (productNumber < 1 || productNumber > 999999) {
            check_error = "[000001 ~ 999999] 사이의 제품순번을 입력해주세요.";
            alert(check_error);
            setInputsRegister({
                ...inputsRegister,
                registerMainSensor: prefixMainSensor
            });
            focusRefRegisterMainSensor.current.focus();
            return;
        }

        let body = {
            sensor: registerMainSensor
        };

        console.log('findSensor', body);
        dispatch(findSensor(body)).then(response => {
            console.log(response);
            setCheckDuplicate(true);
            if (response.payload.findSuccess) {
                if (response.payload.deviceInfo) {
                    setExistMainSensor(true);
                }
            } else {
                if (inputItems[0].value === "") {
                    const inputItemsCopy = JSON.parse(JSON.stringify(inputItems));
                    inputItemsCopy[0].value = prefixNodeSensor;
                    setInputItems(inputItemsCopy);
                }
            }
        })
        .catch((err) => console.log(err));
    };

    // 장비 Part No. Node Sensor + 추가 / - 삭제
    const nextID = useRef(1);
    const [inputItems, setInputItems] = useState([{id: 0, value: '', device: ''}]);

    const addInput = (e) => {
        e.preventDefault();

        console.log('nextID: ', nextID);
        console.log('inputItems: ', inputItems);

        let add_error = "";

        if (!checkDuplicate) {
            add_error = "[Gateway] 입력 후 [중복확인]을 먼저 진행하세요.";
            alert(add_error);
            focusRefRegisterMainSensor.current.focus();
            return;
        }

        if (existMainSensor) {
            add_error = "[Gateway] 동일한 장비 Part No.입니다. [중복확인]을 다시 진행하세요.";
            alert(add_error);
            focusRefRegisterMainSensor.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].value.length === 0 || inputItems[nextID.current - 1].value === undefined) {
            add_error = "[Node Sensor]를 입력해주세요.";
            alert(add_error);
            focusRefRegisterNodeSensor.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].value.length !== setting.sensor_no_total_length) {
            add_error = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(add_error);
            focusRefRegisterNodeSensor.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].value.indexOf(prefixNodeSensor) < 0) {
            add_error = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
            alert(add_error);
            focusRefRegisterNodeSensor.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].device.length === 0 || inputItems[nextID.current - 1].device === undefined) {
            add_error = "[Node Sensor] Device ID를 입력해주세요.";
            alert(add_error);
            focusRefRegisterNodeSensorId.current.focus();
            return;
        }

        if (inputItems[nextID.current - 1].device.length !== setting.sensor_no_total_length + 1) {
            add_error = "[Node Sensor] Device ID는 영.숫자 조합 16자 입니다.";
            alert(add_error);
            focusRefRegisterNodeSensorId.current.focus();
            return;
        }

        if (nextID.current + 1 > setting.sensor_no_node_max_count) {
            add_error = "[Node Sensor] 추가 최대 갯수입니다.";
            alert(add_error);
            return;
        }

        const tempSensor = inputItems[nextID.current - 1].value;
        console.log('tempSensor: ', tempSensor);
        console.log('registerMainSensor: ', registerMainSensor);
        if (tempSensor === registerMainSensor) {
            add_error = "[Node Sensor] 동일한 장비 Part No.입니다. 한번 더 확인해주세요.";
            alert(add_error);
            return;
        }
        const isDuplicateSensor = inputItems.some((item, index) => {
            if (index === nextID.current - 1) return false;
            return item.value === tempSensor;
        });
        if (isDuplicateSensor) {
            add_error = "[Node Sensor] 동일한 장비 Part No.입니다. 한번 더 확인해주세요.";
            alert(add_error);
            return;
        }

        const tempNumber = tempSensor.substring(tempSensor.length - setting.sensor_no_product_number);
        let productNumber = Number(tempNumber);
        if (productNumber < 1 || productNumber > 999999) {
            add_error = "[000001 ~ 999999] 사이의 제품순번을 입력해주세요.";
            alert(add_error);
            focusRefRegisterNodeSensor.current.focus();
            return;
        }
        
        let body = {
            sensor: tempSensor
        };

        console.log('findSensor', body);
        dispatch(findSensor(body)).then(response => {
            // console.log(response);
            if (response.payload.findSuccess) {
                if (response.payload.deviceInfo) {
                    add_error = "[Node Sensor] 동일한 장비 Part No.입니다. 한번 더 확인해주세요.";
                    alert(add_error);
                    return;
                }
            } else {
                const tempSensorId = inputItems[nextID.current - 1].device;

                body = {
                    sensorId: tempSensorId
                };

                dispatch(findSensorId(body)).then(response => {
                    // console.log(response);
                    if (response.payload.findSuccess) {
                        add_error = "[Node Sensor] 동일한 장비 Device ID가 이미 사용중입니다. 한번 더 확인해주세요.";
                        alert(add_error);
                        return;
                    } else {
                        productNumber += 1;

                        const nextNumber = "000000" + productNumber.toString();
                        const nextNodeSensor = prefixNodeSensor + nextNumber.substring(nextNumber.length - setting.sensor_no_product_number);
                
                        let input = {
                            id: nextID.current,
                            value: nextNodeSensor,
                            device: ''
                        };
                        console.log('addInput', input);
                        
                        setInputItems([...inputItems, input]);
                        nextID.current += 1;
                    }
                });
            }
        });
    };

    const deleteInput = (index) => {
        console.log('index', index, 'inputItems length', inputItems.length);
        if (index < inputItems.length - 1) return;

        setInputItems(inputItems.filter(item => item.id !== index));
        nextID.current -= 1;
    };

    const handleChangeNodeSensor = (e, index) => {
        if (index > inputItems.length) return;

        const inputItemsCopy = JSON.parse(JSON.stringify(inputItems));
        // console.log('handleChangeNodeSensor', inputItemsCopy);
        inputItemsCopy[index].value = e.target.value;
        setInputItems(inputItemsCopy);
    };

    const handleChangeNodeSensorId = (e, index) => {
        if (index > inputItems.length) return;

        const inputItemsCopy = JSON.parse(JSON.stringify(inputItems));
        // console.log('handleChangeNodeSensorId', inputItemsCopy);
        inputItemsCopy[index].device = e.target.value;
        setInputItems(inputItemsCopy);
    };

    const handleChangeRegister = (e) => {
        console.log(e.target.name, e.target.value);

        // let regex = /^[0-9]+$/;
        // if (e.target.name === 'registerLifetimeNH3' || e.target.name === 'registerLifetimeH2S' || e.target.name === 'registerLifetimeTH') {
        //     if (!regex.test(e.target.value))
        //         return;
        // }
        let regex = /^[0-9]*$/; // '*'를 사용하여 빈 문자열 허용
        if (['registerLifetimeNH3', 'registerLifetimeH2S', 'registerLifetimeTH'].includes(e.target.name)) {
            if (!regex.test(e.target.value)) return;
        }
        regex = /^[0-9\b -]{0,13}$/;
        if (e.target.name === 'registerUserTel') {
            if (!regex.test(e.target.value))
                return;
        }
        regex = /^[0-9\b -]{0,13}$/;
        if (e.target.name === 'registerUserCellPhone1' || e.target.name === 'registerUserCellPhone2') {
            if (!regex.test(e.target.value))
                return;
        }

        const { value, name } = e.target;
        setInputsRegister({
            ...inputsRegister,
            [name]: value
        });
    };

    useEffect(() => {
        let replaceUserPhone = '';
        // 전화번호
        if (registerUserTel.length === 10) {
            replaceUserPhone = registerUserTel.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsRegister({
                ...inputsRegister,
                registerUserTel: replaceUserPhone
            });
        }
        if (registerUserTel.length === 12) {
            replaceUserPhone = registerUserTel.replace(/-/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsRegister({
                ...inputsRegister,
                registerUserTel: replaceUserPhone
            });
        }
        if (registerUserTel.length === 13) {
            replaceUserPhone = registerUserTel.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsRegister({
                ...inputsRegister,
                registerUserTel: replaceUserPhone
            });
        }
        // 휴대폰 1
        if (registerUserCellPhone1.length === 10) {
            replaceUserPhone = registerUserCellPhone1.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsRegister({
                ...inputsRegister,
                registerUserCellPhone1: replaceUserPhone
            });
        }
        if (registerUserCellPhone1.length === 13) {
            replaceUserPhone = registerUserCellPhone1.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsRegister({
                ...inputsRegister,
                registerUserCellPhone1: replaceUserPhone
            });
        }
        // 휴대폰 2
        if (registerUserCellPhone2.length === 10) {
            replaceUserPhone = registerUserCellPhone2.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            setInputsRegister({
                ...inputsRegister,
                registerUserCellPhone1: replaceUserPhone
            });
        }
        if (registerUserCellPhone2.length === 13) {
            replaceUserPhone = registerUserCellPhone2.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            setInputsRegister({
                ...inputsRegister,
                registerUserCellPhone2: replaceUserPhone
            });
        }
    }, [inputsRegister, registerUserTel, registerUserCellPhone1, registerUserCellPhone2]);

    // 주소검색
    const [enroll_address, setEnroll_address] = useState({
        address: '',
        postal: '',
        latitude: '',
        longitude: ''
    });

    const [popup, setPopup] = useState(false);

    const handleInput = (e) => {
        setEnroll_address({
            ...enroll_address,
            [e.target.name]: e.target.value
        });
    };

    const handleComplete = (data) => {
        setPopup(!popup);
        // console.log('handleComplete', data);
    };

    const f_willChangeDate = (c_month) => {
        let today = new Date();
        let change_day = new Date();

        change_day.setMonth(today.getMonth() + c_month);

        let year = change_day.getFullYear();
        let month = ('0' + (change_day.getMonth() + 1)).slice(-2);
        let day = ('0' + change_day.getDate()).slice(-2);

        let change_date = year + '-' + month + '-' + day;

        return change_date;
    };

    const handleSubmitRegister = (e) => {
        e.preventDefault();
        
        let register_key = "";
        let register_errors = "";

        // 장비 Part No. - Gateway
        if (!checkDuplicate) {
            register_errors = "[Gateway] 입력 후 [중복확인]을 먼저 진행하세요.";
            alert(register_errors);
            focusRefRegisterMainSensor.current.focus();
            return;
        }

        // 장비 Part No. - Node Sensor
        if (inputItems.length === 1) {
            if (inputItems[0].value.length === 0 || inputItems[0].value === undefined) {
                register_errors = "[Node Sensor]를 입력해주세요.";
                alert(register_errors);
                focusRefRegisterNodeSensor.current.focus();
                return;
            }

            if (inputItems[0].value.length !== setting.sensor_no_total_length) {
                register_errors = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
                alert(register_errors);
                focusRefRegisterNodeSensor.current.focus();
                return;
            }
    
            if (inputItems[0].value.indexOf(prefixNodeSensor) < 0) {
                register_errors = "[Node Sensor] 명명 규칙에 따라 올바르게 입력해주세요.";
                alert(register_errors);
                focusRefRegisterNodeSensor.current.focus();
                return;
            }
        }

        const newUser = {
            sensorMain: registerMainSensor,
            sensorNode: inputItems, // registerNodeSensor,
            unitNH3: registerUnitNH3,
            unitH2S: registerUnitH2S,
            unitT: registerUnitTemperature,
            lifetimeNH3: registerLifetimeNH3,
            lifetimeH2S: registerLifetimeH2S,
            lifetimeTH: registerLifetimeTH,
            email: registerUserIdEmail,
            password: registerUserPassword,
            passwordConfirm: registerUserPasswordConfirm,
            company: registerUserCompany,
            tel: registerUserTel,
            address: enroll_address.address, // registerUserAddress,
            addressDetail: registerUserAddressDetail,
            chargeName: registerUserChargeName,
            cellPhone1: registerUserCellPhone1,
            cellPhone2: registerUserCellPhone2
        };

        for (var key in newUser) {
            register_errors = "";

            if (newUser[key].length === 0 || newUser[key] === undefined) {
                register_key = key;

                if (key === 'sensorMain') {
                    register_errors = "[장비 Part No. - Gateway]가 없습니다.";
                } else if (key === 'sensorNode') {
                    register_errors = "[장비 Part No. - Node Sensor]가 없습니다.";
                } else if (key === 'unitNH3') {
                    register_errors = "[측정 단위 - 암모니아]가 없습니다.";
                } else if (key === 'unitH2S') {
                    register_errors = "[측정 단위 - 황화수소]가 없습니다.";
                } else if (key === 'unitT') {
                    register_errors = "[측정 단위 - 온도]가 없습니다.";
                } else if (key === 'lifeTimeNH3') {
                    register_errors = "[센서 수명 - 암모니아]가 없습니다.";
                } else if (key === 'lifeTimeH2S') {
                    register_errors = "[센서 수명 - 황화수소]가 없습니다.";
                } else if (key === 'lifeTimeTH') {
                    register_errors = "[센서 수명 - 온/습도]가 없습니다.";
                } else if (key === 'email') {
                    register_errors = "[아이디]가 없습니다.";
                } else if (key === 'password') {
                    register_errors = "[비밀번호]가 없습니다.";
                } else if (key === 'passwordConfirm') {
                    register_errors = "[비밀번호 확인]이 없습니다."
                } else if (key === 'company') {
                    register_errors = "[상호]가 없습니다.";
                } else if (key === 'tel') {
                    register_errors = "[전화번호]가 없습니다.";
                } else if (key === 'address') {
                    register_errors = "[주소]가 없습니다. [주소검색]을 이용하여 입력해주세요.";
                } else if (key === 'chargeName') {
                    register_errors = "[담당자]가 없습니다.";
                } else if (key === 'cellPhone1') {
                    register_errors = "[휴대폰 1]이 없습니다.";
                } else if (key === 'cellPhone2') {
                    // register_errors = "[휴대폰 2]가 없습니다."; // 휴대폰 1만 입력해도 된다.
                }
            }

            if (register_errors.length > 1)
                break;
        }

        if (register_errors.length > 1) {
            alert(register_errors);

            if (register_key === 'sensorMain') {
                focusRefRegisterMainSensor.current.focus();
            } else if (register_key === 'sensorNode') {
                focusRefRegisterNodeSensor.current.focus();
            } else if (register_key === 'lifeTimeNH3') {
                focusRefRegisterLifetimeNH3.current.focus();
            } else if (register_key === 'lifeTimeH2S') {
                focusRefRegisterLifetimeH2S.current.focus();
            } else if (register_key === 'lifeTimeTH') {
                focusRefRegisterLifetimeTH.current.focus();
            } else if (register_key === 'email') {
                focusRefRegisterUserIdEmail.current.focus();
            } else if (register_key === 'password') {
                focusRefRegisterUserPassword.current.focus();
            } else if (register_key === 'passwordConfirm') {
                focusRefRegisterUserPasswordConfirm.current.focus();
            } else if (register_key === 'company') {
                focusRefRegisterUserCompany.current.focus();
            } else if (register_key === 'tel') {
                focusRefRegisterUserTel.current.focus();
            } else if (register_key === 'address') {
                focusRefRegisterUserAddress.current.focus();
            } else if (register_key === 'chargeName') {
                focusRefRegisterUserChargeName.current.focus();
            } else if (register_key === 'cellPhone1') {
                focusRefRegisterUserCellPhone1.current.focus();
            }

            return;
        }

        // 센서 수명 - 암모니아
        if (Number(registerLifetimeNH3) < 1) {
            register_errors = "암모니아 센서 수명은 1개월 이상 입력해주세요.";
            alert(register_errors);
            setInputsRegister({
                ...inputsRegister,
                registerLifeTimeNH3: ""
            });
            focusRefRegisterLifetimeNH3.current.focus();
            return;
        }
        // 센서 수명 - 황화수소
        if (Number(registerLifetimeH2S) < 1) {
            register_errors = "황화수소 센서 수명은 1개월 이상 입력해주세요.";
            alert(register_errors);
            setInputsRegister({
                ...inputsRegister,
                registerLifeTimeH2S: ""
            });
            focusRefRegisterLifetimeH2S.current.focus();
            return;
        }
        // 센서 수명 - 온/습도
        if (Number(registerLifetimeTH) < 1) {
            register_errors = "온/습도 센서 수명은 1개월 이상 입력해주세요.";
            alert(register_errors);
            setInputsRegister({
                ...inputsRegister,
                registerLifeTimeTH: ""
            });
            focusRefRegisterLifetimeTH.current.focus();
            return;
        }

        // 아이디
        const emailRegex =
        /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!emailRegex.test(registerUserIdEmail)) {
            register_errors = "올바른 아이디(이메일)을 입력해주세요.";
            alert(register_errors);
            focusRefRegisterUserIdEmail.current.focus();
            return;
        }
  
        // 비밀번호
        const passwordRegex =
        /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
        if (!passwordRegex.test(registerUserPassword)) {
            register_errors = "영문, 숫자, 특수문자 포함 8자 이상 입력해주세요.";
            alert(register_errors);
            focusRefRegisterUserPassword.current.focus();
            return;
        }

        // 비밀번호 확인
        if (registerUserPassword !== registerUserPasswordConfirm) {
            register_errors = "비밀번호가 틀려요. 다시 확인해주세요.";
            alert(register_errors);
            setInputsRegister({
                ...inputsRegister,
                registerUserPasswordConfirm: ""
            });
            focusRefRegisterUserPasswordConfirm.current.focus();
            return;
        }
  
        // 상호
        if (registerUserCompany.length < 2 || registerUserCompany.length > 30) {
            register_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(register_errors);
            focusRefRegisterUserCompany.current.focus();
            return;
        }

        // 전화번호

        // 주소

        // 담당자
        if (registerUserChargeName.length < 2 || registerUserChargeName.length > 30) {
            register_errors = "2글자 이상 30글자 미만으로 입력해주세요.";
            alert(register_errors);
            focusRefRegisterUserChargeName.current.focus();
            return;
        }

        // 휴대폰 1

        // 휴대폰 2

        let body = {
            email: registerUserIdEmail,
            password: registerUserPassword,
            company: registerUserCompany,
            tel: registerUserTel,
            address: enroll_address.address,
            addressDetail: registerUserAddressDetail,
            postal: enroll_address.postal,
            latitude: enroll_address.latitude,
            longitude: enroll_address.longitude,
            chargeName: registerUserChargeName,
            cellPhone1: registerUserCellPhone1,
            cellPhone2: registerUserCellPhone2,
            sensorMain: registerMainSensor,
            sensorNode: inputItems
        };

        let register_msg = "";

        console.log('findUser', body);
        dispatch(findUser(body)).then(response => {
            if (response.payload.findSuccess) {
                let userInfo = response.payload.userInfo;
                if (userInfo.accountActive === "Y") {
                    register_msg = "등록된 [" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자가 있습니다.";
                    alert(register_msg);
                } else {
                    console.log('updateUser', body);
                    dispatch(updateUser(body)).then(response => {
                        if (response.payload.updateSuccess) {
                            body = {
                                id: registerUserIdEmail,
                                sensorMain: registerMainSensor,
                                unitNH3: Number(registerUnitNH3),
                                unitH2S: Number(registerUnitH2S),
                                unitT: Number(registerUnitTemperature),
                                lifetimeNH3: Number(registerLifetimeNH3),
                                lifetimeH2S: Number(registerLifetimeH2S),
                                lifetimeTH: Number(registerLifetimeTH)
                            };
                            console.log('findSetting', body);
                            dispatch(findSetting(body)).then(response => {
                                if (response.payload.findSuccess) {
                                    console.log('updateSetting', body);
                                    dispatch(updateSetting(body)).then(response => {
                                        if (response.payload.updateSuccess) {
                                            body = {
                                                id: registerUserIdEmail,
                                                sensorNumber: registerMainSensor
                                            };
                                            console.log('findDevice', body);
                                            dispatch(findDevice(body)).then(response => {
                                                body = {
                                                    id: registerUserIdEmail,
                                                    sensorNumber: registerMainSensor,
                                                    willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                    willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                    willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                    guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                };
                                                if (response.payload.findSuccess) {
                                                    console.log('updateDevice', body);
                                                    dispatch(updateDevice(body)).then(response => {
                                                        if (response.payload.updateSuccess) {
                                                            let indexItem = 0;
                                                            inputItems.forEach(el => {
                                                                body = {
                                                                    id: registerUserIdEmail,
                                                                    sensorNumber: el.value,
                                                                    sensorId: el.device,
                                                                    willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                                    willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                                    willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                                    guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                                };
                                                                console.log('updateDevice', body);
                                                                dispatch(updateDevice(body)).then(response => {
                                                                    indexItem =+ 1;
                                                                    if (indexItem >= inputItems.length) {
                                                                        if (response.payload.updateSuccess) {
                                                                            register_msg = "[" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자 추가 되었습니다.";
                                                                            alert(register_msg);
                                                                            window.location.replace('/Registration');
                                                                        }
                                                                    }
                                                                });       
                                                            });
                                                        }
                                                    });
                                                } else {
                                                    console.log('registerDevice')
                                                    dispatch(registerDevice(body)).then(response => {
                                                        if (response.payload.registerSuccess) {
                                                            let indexItem = 0;
                                                            inputItems.forEach(el => {
                                                                body = {
                                                                    id: registerUserIdEmail,
                                                                    sensorNumber: el.value,
                                                                    sensorId: el.device,
                                                                    willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                                    willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                                    willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                                    guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                                };
                                                                console.log('registerDevice', body);
                                                                dispatch(registerDevice(body)).then(response => {
                                                                    indexItem += 1;
                                                                    if (indexItem >= inputItems.length) {
                                                                        if (response.payload.registerSuccess) {
                                                                            register_msg = "[" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자 추가 되었습니다.";
                                                                            alert(register_msg);
                                                                            window.location.replace('/Registration');
                                                                        }
                                                                    }
                                                                });
                                                            });
                                                        }
                                                    });
                                                }
                                            });
                                        } else {
                                            alert(response.payload.message);
                                        }
                                    });
                                } else {
                                    console.log('registerSetting', body);
                                    dispatch(registerSetting(body)).then(response => {
                                        if (response.payload.registerSuccess) {
                                            body = {
                                                id: registerUserIdEmail,
                                                sensorNumber: registerMainSensor
                                            };
                                            console.log('findDevice', body);
                                            dispatch(findDevice(body)).then(response => {
                                                body = {
                                                    id: registerUserIdEmail,
                                                    sensorNumber: registerMainSensor,
                                                    willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                    willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                    willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                    guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                };
                                                if (response.payload.findSuccess) {
                                                    console.log('updateDevice', body);
                                                    dispatch(updateDevice(body)).then(response => {
                                                        if (response.payload.updateSuccess) {
                                                            let indexItem = 0;
                                                            inputItems.forEach(el => {
                                                                body = {
                                                                    id: registerUserIdEmail,
                                                                    sensorNumber: el.value,
                                                                    sensorId: el.device,
                                                                    willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                                    willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                                    willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                                    guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                                };
                                                                console.log('updateDevice', body);
                                                                dispatch(updateDevice(body)).then(response => {
                                                                    indexItem =+ 1;
                                                                    if (indexItem >= inputItems.length) {
                                                                        if (response.payload.updateSuccess) {
                                                                            register_msg = "[" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자 추가 되었습니다.";
                                                                            alert(register_msg);
                                                                            window.location.replace('/Registration');
                                                                        }
                                                                    }
                                                                });       
                                                            });
                                                        }
                                                    });
                                                } else {
                                                    console.log('registerDevice')
                                                    dispatch(registerDevice(body)).then(response => {
                                                        if (response.payload.registerSuccess) {
                                                            let indexItem = 0;
                                                            inputItems.forEach(el => {
                                                                body = {
                                                                    id: registerUserIdEmail,
                                                                    sensorNumber: el.value,
                                                                    sensorId: el.device,
                                                                    willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                                    willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                                    willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                                    guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                                };
                                                                console.log('registerDevice', body);
                                                                dispatch(registerDevice(body)).then(response => {
                                                                    indexItem += 1;
                                                                    if (indexItem >= inputItems.length) {
                                                                        if (response.payload.registerSuccess) {
                                                                            register_msg = "[" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자 추가 되었습니다.";
                                                                            alert(register_msg);
                                                                            window.location.replace('/Registration');
                                                                        }
                                                                    }
                                                                });
                                                            });
                                                        }
                                                    });
                                                }
                                            });
                                        } else {
                                            alert(response.payload.message);
                                        }
                                    }).catch((err) => console.log(err));
                                }
                            });
                        } else {
                            alert(response.payload.message);
                        }
                    });
                }
            } else {
                console.log('registerUser', body);
                dispatch(registerUser(body)).then(response => {
                    if (response.payload.registerSuccess) {
                        body = {
                            id: registerUserIdEmail,
                            sensorMain: registerMainSensor,
                            unitNH3: Number(registerUnitNH3),
                            unitH2S: Number(registerUnitH2S),
                            unitT: Number(registerUnitTemperature),
                            lifetimeNH3: Number(registerLifetimeNH3),
                            lifetimeH2S: Number(registerLifetimeH2S),
                            lifetimeTH: Number(registerLifetimeTH)
                        };
                        console.log('findSetting', body);
                        dispatch(findSetting(body)).then(response => {
                            if (response.payload.findSuccess) {
                                console.log('updateSetting', body);
                                dispatch(updateSetting(body)).then(response => {
                                    if (response.payload.updateSuccess) {
                                        body = {
                                            id: registerUserIdEmail,
                                            sensorNumber: registerMainSensor
                                        };
                                        console.log('findDevice', body);
                                        dispatch(findDevice(body)).then(response => {
                                            body = {
                                                id: registerUserIdEmail,
                                                sensorNumber: registerMainSensor,
                                                willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                            };
                                            if (response.payload.findSuccess) {
                                                console.log('updateDevice', body);
                                                dispatch(updateDevice(body)).then(response => {
                                                    if (response.payload.updateSuccess) {
                                                        let indexItem = 0;
                                                        inputItems.forEach(el => {
                                                            body = {
                                                                id: registerUserIdEmail,
                                                                sensorNumber: el.value,
                                                                sensorId: el.device,
                                                                willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                                willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                                willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                                guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                            };
                                                            console.log('updateDevice', body);
                                                            dispatch(updateDevice(body)).then(response => {
                                                                indexItem =+ 1;
                                                                if (indexItem >= inputItems.length) {
                                                                    if (response.payload.updateSuccess) {
                                                                        register_msg = "[" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자 추가 되었습니다.";
                                                                        alert(register_msg);
                                                                        window.location.replace('/Registration');
                                                                    }
                                                                }
                                                            });       
                                                        });
                                                    }
                                                });
                                            } else {
                                                console.log('registerDevice')
                                                dispatch(registerDevice(body)).then(response => {
                                                    if (response.payload.registerSuccess) {
                                                        let indexItem = 0;
                                                        inputItems.forEach(el => {
                                                            body = {
                                                                id: registerUserIdEmail,
                                                                sensorNumber: el.value,
                                                                sensorId: el.device,
                                                                willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                                willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                                willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                                guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                            };
                                                            console.log('registerDevice', body);
                                                            dispatch(registerDevice(body)).then(response => {
                                                                indexItem += 1;
                                                                if (indexItem >= inputItems.length) {
                                                                    if (response.payload.registerSuccess) {
                                                                        register_msg = "[" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자 추가 되었습니다.";
                                                                        alert(register_msg);
                                                                        window.location.replace('/Registration');
                                                                    }
                                                                }
                                                            });
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    } else {
                                        alert(response.payload.message);
                                    }
                                });
                            } else {
                                console.log('registerSetting', body);
                                dispatch(registerSetting(body)).then(response => {
                                    if (response.payload.registerSuccess) {
                                        body = {
                                            id: registerUserIdEmail,
                                            sensorNumber: registerMainSensor
                                        };
                                        console.log('findDevice', body);
                                        dispatch(findDevice(body)).then(response => {
                                            body = {
                                                id: registerUserIdEmail,
                                                sensorNumber: registerMainSensor,
                                                willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                            };
                                            if (response.payload.findSuccess) {
                                                console.log('updateDevice', body);
                                                dispatch(updateDevice(body)).then(response => {
                                                    if (response.payload.updateSuccess) {
                                                        let indexItem = 0;
                                                        inputItems.forEach(el => {
                                                            body = {
                                                                id: registerUserIdEmail,
                                                                sensorNumber: el.value,
                                                                sensorId: el.device,
                                                                willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                                willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                                willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                                guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                            };
                                                            console.log('updateDevice', body);
                                                            dispatch(updateDevice(body)).then(response => {
                                                                indexItem =+ 1;
                                                                if (indexItem >= inputItems.length) {
                                                                    if (response.payload.updateSuccess) {
                                                                        register_msg = "[" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자 추가 되었습니다.";
                                                                        alert(register_msg);
                                                                        window.location.replace('/Registration');
                                                                    }
                                                                }
                                                            });       
                                                        });
                                                    }
                                                });
                                            } else {
                                                console.log('registerDevice')
                                                dispatch(registerDevice(body)).then(response => {
                                                    if (response.payload.registerSuccess) {
                                                        let indexItem = 0;
                                                        inputItems.forEach(el => {
                                                            body = {
                                                                id: registerUserIdEmail,
                                                                sensorNumber: el.value,
                                                                sensorId: el.device,
                                                                willChangeDateNH3: f_willChangeDate(Number(registerLifetimeNH3)),
                                                                willChangeDateH2S: f_willChangeDate(Number(registerLifetimeH2S)),
                                                                willChangeDateTH: f_willChangeDate(Number(registerLifetimeTH)),
                                                                guaranteeExpirationDate: f_willChangeDate(12 * setting.sensor_guarantee_period)
                                                            };
                                                            console.log('registerDevice', body);
                                                            dispatch(registerDevice(body)).then(response => {
                                                                indexItem += 1;
                                                                if (indexItem >= inputItems.length) {
                                                                    if (response.payload.registerSuccess) {
                                                                        register_msg = "[" + registerUserIdEmail + " (" + registerUserCompany + ")] 사용자 추가 되었습니다.";
                                                                        alert(register_msg);
                                                                        window.location.replace('/Registration');
                                                                    }
                                                                }
                                                            });
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    } else {
                                        alert(response.payload.message);
                                    }
                                }).catch((err) => console.log(err));
                            }
                        });
                    } else {
                        alert(response.payload.message);
                    }
                }).catch((err) => console.log(err));
            }
        }).catch((err) => console.log(err));
    };

    const [showRegisterPassword, setShowRegisterPassword] = useState(false);
    const handleClickShowRegisterPassword = () => setShowRegisterPassword((show) => !show);
    const handleMouseDownRegisterPassword = (event) => {
      event.preventDefault();
    };

    const [showRegisterPasswordConfirm, setShowRegisterPasswordConfirm] = useState(false);
    const handleClickShowRegisterPasswordConfirm = () => setShowRegisterPasswordConfirm((show) => !show);
    const handleMouseDownRegisterPasswordConfirm = (event) => {
      event.preventDefault();
    };

    const handelCancelRegister = () => {
        window.location.replace('/Registration');
    };

    return (
        <div className="container">
            <div className="header-wrap">
                <div className="headerBtn">
                    <h1>등록 관리</h1>
                    <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '0px 32px', border: 'none', color:'white', marginLeft: '32px', fontSize: '16px'}} 
                            variant="outlined" href="/Registration">
                            신규 등록
                    </Button>
                    <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '0px 32px', border: 'none', color:'white', marginLeft: '16px', fontSize: '16px'}} 
                            variant="outlined" href="/RegistrationUser">
                            사용자 관리
                    </Button>
                </div>
                <div className="info-wrap">
                    <div className="info-id">
                        <span>{adminAccount.name}</span>
                        <button className="logout-btn" onClick={onLogoutHandler}>로그아웃</button>
                    </div>
                    <div className="info-email">
                        {adminAccount.email}
                    </div>
                </div>
            </div>

            <div className="bodyRegistration">
                <div className="RegistrationGrop1">
                    <div className="RegistrationLayout">
                        <div className="setting-layout-header">
                            <h3>장비 및 사용자 신규 등록</h3> <span>New equipment and user registration</span>
                        </div>
                        <div className="RegistrationBody">
                            <div className="textInputListFull">
                                <span className="listTitle">장비 Part No.</span>
                                <div className="sensorWrap">
                                    <span className="sensor">
                                        Gateway
                                    </span>
                                    <input
                                        id="registerMainSensor"
                                        name="registerMainSensor"
                                        value={registerMainSensor}
                                        onChange={handleChangeRegister}
                                        required
                                        ref={focusRefRegisterMainSensor}
                                        className="textInput5"
                                        type="text"
                                        placeholder="EMS01-GW-000001" />
                                    <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 32px', border: 'none', color:'#120C0E'}}
                                            onClick={handleCheckDuplicate}
                                            variant="outlined">
                                            중복확인
                                    </Button>
                                {
                                    checkDuplicate &&
                                    <Stack sx={{ width: '742px' }} spacing={2}>
                                    {
                                        existMainSensor &&
                                        <Alert variant="outlined" severity="error" style={{ padding: '2px 16px', margin: '8px 0 0 16px' }}>
                                            동일한 장비 Part No.입니다. 한번 더 확인해주세요.
                                        </Alert>
                                    }
                                    {
                                        !existMainSensor &&
                                        <Alert variant="outlined" severity="success" style={{ padding: '2px 16px', margin: '8px 0 0 16px' }}>
                                            장비 Part No. 중복확인 완료
                                        </Alert>
                                    }
                                    </Stack>
                                }
                                </div>
                            </div>
                        {
                            inputItems.map((item, index) => (
                            <div className="textInputListFull">
                                <span className="listTitle"></span>
                                <div className="sensorWrap">
                                    <span className="sensor">
                                        Node Sensor
                                    </span>
                                    <input
                                        id={`registerNodeSensor-${index}`}
                                        name={`registerNodeSensor-${index}`}
                                        value={item.value}
                                        onChange={(e) => handleChangeNodeSensor(e, index)}
                                        required
                                        ref={item.id === index && focusRefRegisterNodeSensor}
                                        className="textInput5"
                                        type="text"
                                        placeholder="EMS01-NS-000001" />
                                    <input
                                        id={`registerNodeSensorId-${index}`}
                                        name={`registerNodeSensorId-${index}`}
                                        value={item.device}
                                        onChange={(e) => handleChangeNodeSensorId(e, index)}
                                        required
                                        ref={item.id === index && focusRefRegisterNodeSensorId}
                                        className="textInputId"
                                        type="text"
                                        maxLength={16} />
                            {
                                index === 0 && (
                                    <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 36px', border: 'none', color:'#120C0E'}}
                                            onClick={addInput}
                                            variant="outlined">
                                            + 추가
                                    </Button>
                                )
                            }
                            {
                                index > 0 && index === item.id && (
                                    <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 36px', border: 'none', color:'#120C0E'}}
                                            onClick={() => deleteInput(item.id)}
                                            variant="outlined">
                                            - 삭제
                                    </Button>
                                )
                            }
                                </div>
                            </div>
                            ))
                        }
                            <div className="textInputListFull2">
                                <span className="listTitle">측정 단위</span>
                                <div>
                                    <div className="sensorWrap2">
                                        <span className="subListText">
                                            암모니아
                                        </span>
                                        <div className="Radio">
                                            <FormControl>
                                                <RadioGroup
                                                    id="registerUnitNH3"
                                                    name="registerUnitNH3"
                                                    value={registerUnitNH3}
                                                    onChange={handleChangeRegister}
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                >
                                                    <FormControlLabel value="0" control={<Radio />} label="ppm" />
                                                    <FormControlLabel value="1" control={<Radio />} label="ppb" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </div>

                                    <div className="sensorWrap2">
                                        <span className="subListText">
                                            황화수소
                                        </span>
                                        <div className="Radio">
                                            <FormControl>
                                                <RadioGroup
                                                    id="registerUnitH2S"
                                                    name="registerUnitH2S"
                                                    value={registerUnitH2S}
                                                    onChange={handleChangeRegister}
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                >
                                                    <FormControlLabel value="0" control={<Radio />} label="ppm" />
                                                    <FormControlLabel value="1" control={<Radio />} label="ppb" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </div>

                                    <div className="sensorWrap2">
                                        <span className="subListText">
                                            온도
                                        </span>
                                        <div className="Radio">
                                            <FormControl>
                                                <RadioGroup
                                                    id="registerUnitTemperature"
                                                    name="registerUnitTemperature"
                                                    value={registerUnitTemperature}
                                                    onChange={handleChangeRegister}
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                >
                                                    <FormControlLabel value="0" control={<Radio />} label="℃" />
                                                    &nbsp;&nbsp;&nbsp;
                                                    <FormControlLabel value="1" control={<Radio />} label="℉" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="textInputListFull2">
                                <span className="listTitle">센서 수명</span>
                                <div>
                                    <div className="sensorWrap2">
                                        <span className="subListText2">
                                            암모니아
                                        </span>
                                        <input
                                            id="registerLifetimeNH3"
                                            name="registerLifetimeNH3"
                                            value={registerLifetimeNH3}
                                            onChange={handleChangeRegister}
                                            required
                                            ref={focusRefRegisterLifetimeNH3}
                                            className="textInput6"
                                            type="text"
                                            maxLength={2}
                                            placeholder="00" />
                                            개월
                                    </div>

                                    <div className="sensorWrap2">
                                        <span className="subListText2">
                                            황화수소
                                        </span>
                                        <input
                                            id="registerLifetimeH2S"
                                            name="registerLifetimeH2S"
                                            value={registerLifetimeH2S}
                                            onChange={handleChangeRegister}
                                            required
                                            ref={focusRefRegisterLifetimeH2S}
                                            className="textInput6"
                                            type="text"
                                            maxLength={2}
                                            placeholder="00" />
                                            개월
                                    </div>

                                    <div className="sensorWrap2">
                                        <span className="subListText2">
                                            온/습도
                                        </span>
                                        <input
                                            id="registerLifetimeTH"
                                            name="registerLifetimeTH"
                                            value={registerLifetimeTH}
                                            onChange={handleChangeRegister}
                                            required
                                            ref={focusRefRegisterLifetimeTH}
                                            className="textInput6"
                                            type="text"
                                            maxLength={2}
                                            placeholder="00" />
                                            개월
                                    </div>
                                </div>
                            </div>

                            <div className="textInputListFull">
                                <span className="listTitle">아이디</span>                      
                                <input
                                    id="registerUserIdEmail"
                                    name="registerUserIdEmail"
                                    value={registerUserIdEmail}
                                    onChange={handleChangeRegister}
                                    required
                                    ref={focusRefRegisterUserIdEmail}
                                    className="textInput7"
                                    type="text"
                                    placeholder="아이디를 입력하세요" />
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">비밀번호</span>                      
                                <FormControl sx={{ width: '30%' }} variant="outlined">
                                    <OutlinedInput
                                        style={{ border: '1px', borderRadius: '8px', marginLeft: '16px', padding: '12px 12px 12px 2px',  height: '42px' }}
                                        id="registerUserPassword"
                                        name="registerUserPassword"
                                        value={registerUserPassword}
                                        onChange={handleChangeRegister}
                                        inputRef={focusRefRegisterUserPassword}
                                        type={showRegisterPassword ? 'text' : 'password'}
                                        placeholder="비밀번호를 입력해주세요"
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    arial-label="toggle password visibility"
                                                    onClick={handleClickShowRegisterPassword}
                                                    onMouseDown={handleMouseDownRegisterPassword}
                                                    edge="end"
                                                >
                                                    {showRegisterPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">비밀번호 확인</span>                      
                                <FormControl sx={{ width: '30%' }} variant="outlined">
                                    <OutlinedInput
                                        style={{ border: '1px', borderRadius: '8px', marginLeft: '16px', padding: '12px 12px 12px 2px',  height: '42px' }}
                                        id="registerUserPasswordConfirm"
                                        name="registerUserPasswordConfirm"
                                        value={registerUserPasswordConfirm}
                                        onChange={handleChangeRegister}
                                        inputRef={focusRefRegisterUserPasswordConfirm}
                                        type={showRegisterPasswordConfirm ? 'text' : 'password'}
                                        placeholder="비밀번호를 한번 더 입력해주세요"
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    arial-label="toggle password visibility"
                                                    onClick={handleClickShowRegisterPasswordConfirm}
                                                    onMouseDown={handleMouseDownRegisterPasswordConfirm}
                                                    edge="end"
                                                >
                                                    {showRegisterPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">상호</span>                      
                                <input
                                    id="registerUserCompany"
                                    name="registerUserCompany"
                                    value={registerUserCompany}
                                    onChange={handleChangeRegister}
                                    required
                                    ref={focusRefRegisterUserCompany}
                                    className="textInput7"
                                    type="text"
                                    placeholder="상호를 입력하세요" />
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">전화번호</span>                      
                                <input
                                    id="registerUserTel"
                                    name="registerUserTel"
                                    value={registerUserTel}
                                    onChange={handleChangeRegister}
                                    required
                                    ref={focusRefRegisterUserTel}
                                    className="textInput7"
                                    type="text"
                                    placeholder="전화번호를 입력하세요" />
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">주소</span>                      
                                <input
                                    id="address"
                                    name="address"
                                    value={enroll_address.address}
                                    onChange={handleInput}
                                    required
                                    readOnly
                                    // ref={focusRefRegisterUserAddress}
                                    className="textInput7"
                                    type="text"
                                    placeholder="주소를 입력하세요" />
                                <Button style={{backgroundColor: '#F5F6FF', borderRadius:'8px', padding: '12px 32px', border: 'none', color:'#120C0E'}}
                                        onClick={handleComplete}
                                        ref={focusRefRegisterUserAddress}
                                        variant="outlined">
                                        주소검색
                                </Button>
                                {
                                    popup &&
                                    <Post address={enroll_address} setaddress={setEnroll_address} onClose={handleComplete}></Post>
                                }
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">상세주소</span>                      
                                <input
                                    id="registerUserAddressDetail"
                                    name="registerUserAddressDetail"
                                    value={registerUserAddressDetail}
                                    onChange={handleChangeRegister}
                                    ref={focusRefRegisterUserAddressDetail}
                                    className="textInput7"
                                    type="text"
                                    placeholder="상세주소를 입력하세요" />
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">담당자</span>                      
                                <input
                                    id="registerUserChargeName"
                                    name="registerUserChargeName"
                                    value={registerUserChargeName}
                                    onChange={handleChangeRegister}
                                    required
                                    ref={focusRefRegisterUserChargeName}
                                    className="textInput7"
                                    type="text"
                                    placeholder="담당자 이름을 입력하세요" />
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">휴대폰 1</span>                      
                                <input
                                    id="registerUserCellPhone1"
                                    name="registerUserCellPhone1"
                                    value={registerUserCellPhone1}
                                    onChange={handleChangeRegister}
                                    required
                                    ref={focusRefRegisterUserCellPhone1}
                                    className="textInput7"
                                    type="text"
                                    placeholder="휴대폰 1을 입력하세요" />
                            </div>
                            <div className="textInputListFull">
                                <span className="listTitle">휴대폰 2</span>                      
                                <input
                                    id="registerUserCellPhone2"
                                    name="registerUserCellPhone2"
                                    value={registerUserCellPhone2}
                                    onChange={handleChangeRegister}
                                    required
                                    ref={focusRefRegisterUserCellPhone2}
                                    className="textInput7"
                                    type="text"
                                    placeholder="휴대폰 2를 입력하세요" />
                            </div>
                            <div>
                                <Button style={{backgroundColor: '#4e82eb', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 32px', border: 'none', color:'white', fontSize: '16px'}}
                                        onClick={handleSubmitRegister}
                                        variant="outlined">
                                        등 록
                                </Button>
                                <Button style={{backgroundColor: '#DADADA', borderRadius:'8px', padding: '8px 80px', margin: '32px 0 64px 16px', border: 'none', color:'white', fontSize: '16px'}}
                                        onClick={handelCancelRegister}
                                        variant="outlined">
                                        취 소
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
    )
}

export default Registration;
